var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "402px",
    height: "165px",
    viewBox: "0 0 402 165",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8815918,39.315155 L42.8805951,78.203155 L59.8085932,64.5 L77.3611277,64.5 L42.8805951,94.947155 L42.8805951,95.051155 L77.3611277,125.5 L59.8085932,125.5 L42.8805951,111.796155 L42.8815918,125.180389 L30.7505951,125.180389 L30.7505951,39.315155 L42.8815918,39.315155 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.881592,39.315155 L270.880595,78.203155 L287.808593,64.5 L305.361128,64.5 L270.880595,94.947155 L270.880595,95.051155 L305.361128,125.5 L287.808593,125.5 L270.880595,111.796155 L270.881592,125.180389 L258.750595,125.180389 L258.750595,39.315155 L270.881592,39.315155 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,64 C240.255374,64 250.109752,69.9983799 255.540775,78.9727816 L245.43474,84.3464044 C241.921539,79.2577133 236.04891,75.9230769 229.397436,75.9230769 C218.642044,75.9230769 209.923077,84.6420444 209.923077,95.3974359 C209.923077,106.152827 218.642044,114.871795 229.397436,114.871795 C236.707132,114.871795 243.076208,110.84452 246.406878,104.887756 L255.755438,110.667022 C250.372025,119.840758 240.405297,126 229,126 C211.879173,126 198,112.120827 198,95 C198,77.8791728 211.879173,64 229,64 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,64 C181.120827,64 195,77.8791728 195,95 C195,112.120827 181.120827,126 164,126 C146.879173,126 133,112.120827 133,95 C133,77.8791728 146.879173,64 164,64 Z M164.5,76 C153.730447,76 145,84.7304474 145,95.5 C145,106.269553 153.730447,115 164.5,115 C175.269553,115 184,106.269553 184,95.5 C184,84.7304474 175.269553,76 164.5,76 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.053421,125.841995 L82.4828644,125.841995 L82.4828644,88.1979218 C82.3699493,79.5461782 85.1064148,73.1468709 90.6922607,69 C96.2781067,64.8531291 102.02209,63.1338196 107.92421,63.8420715 C113.929988,64.0594991 119.081009,66.522644 123.377274,71.2315063 C127.673538,75.9403687 129.861094,81.5958405 129.939941,88.1979218 L129.939941,125.841995 L119.142944,125.841995 L119.142944,89.91362 C119.13621,85.7343699 117.98261,82.6832275 115.682144,80.7601929 C113.381678,78.8371582 110.7957,77.7599487 107.92421,77.5285645 C104.027746,77.0990702 100.741831,78.1762797 98.0664673,80.7601929 C95.3911031,83.344106 94.053421,86.3952484 94.053421,89.91362 L94.053421,125.841995 Z",
    id: "Path-2",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4555FF",
    x: 310,
    y: 20,
    width: 67,
    height: 44,
    rx: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#FFFFFF",
    points: "331.5 30 343 53 320 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#FFFFFF",
    points: "331.5 30 343 53 320 53"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 356.5,
    cy: 41.5,
    r: 11.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e01fdb28c015919dff5953e7a4b32fa8.svg";
export { ForwardRef as ReactComponent };